import * as types from './sample.actions'
import * as records from '../record/record.actions';
import {RECORD_SAVED} from "../record/record.actions";

export const initialState = {
  uploaded: false,
  entities: {
    facilityStatus: {},
    patients: {},
    periods: {}
  },
  selectedPeriod: null,
  removedPatientIds: [],
  notifyingNursingFacilities: false,
  filters: {
    facility: '',
    reviewer: '',
    recordStatus: ''
  },
  uiState: {
    activeTab: undefined
  }
};

export default function (state = initialState, action) {
  switch (action.type) {

    case types.PERIOD_RETRIEVED:
      const {removedPatientIds, selectedPeriod} = action.payload;
      console.log('PERIOD_RETRIEVED payload', action.payload)

      return {
        ...state,
        fetching: false,
        uploaded: false,
        selectedPeriod,
        removedPatientIds,
        entities: {
          ...state.entities,
          patients: {},
          ...action.payload.entities    
        }
      };

    case types.PATIENT_REMOVED_FROM_SAMPLE:
      return {
        ...state,
        removedPatientIds: [...state.removedPatientIds, action.payload.recordId],
        entities: {
          ...state.entities,
          periods: {...state.entities.periods, 
          [action.payload.periodId]: {
            ...state.entities.periods[action.payload.periodId],
            quarterlyStatus: action.payload.quarterlyStatus,
            quarterlyStatusValue: action.payload.quarterlyStatusValue
          }}
        }
      };

    case types.PATIENT_RESTORED_TO_SAMPLE:
      return {
        ...state,
        removedPatientIds: state.removedPatientIds.filter(x => x !== action.payload.recordId)
      };

    case types.SAMPLE_DATA_UPLOADED:
      return {
        ...state,
        uploaded: true,
        fetching: false,
        entities: {
          ...state.entities,
          patients: {...action.payload.entities.patients, ...state.entities.patients}
        }
      };

    case records.DOCUMENTATION_UPLOADED:
      const upload = action.payload.entities.documentation[action.payload.result];
      return {
        ...state,
        entities: {
          ...state.entities,
          patients: {
            ...state.entities.patients,
            [upload.recordId]: {
              ...state.entities.patients[upload.recordId],
              recordStatus: upload.recordStatus,
              recordStatusValue: upload.recordStatusValue
            }
          }
        }
      };

    case RECORD_SAVED:
      return updateRecord(state, action);

    case types.SAMPLE_DATA_CLEARED:
      return {
        ...state,
        uploaded: false,
        filters: {
          ...initialState.filters
        },
        entities: {
          ...state.entities,
          patients: {},
          periods: {
            ...state.entities.periods,
            [state.selectedPeriod]: {
              ...state.entities.periods[state.selectedPeriod],
              ...action.payload,
              dueDate: null
            }
          }
        }
      };

    case types.FILTERS_SET:
      return {
        ...state,
        filters: {...action.payload}
      };
    case types.FILTERS_CLEARED:
      return {
        ...state,
        filters: {
          ...initialState.filters
        }
      };

    case types.NOTIFY_NURSING_FACILITIES:
      return {
        ...state,
        notifyingNursingFacilities: true
      };

    case types.NURSING_FACILITIES_NOTIFIED:
      return {
        ...state,
        notifyingNursingFacilities: false,
        entities: {
          ...state.entities,
          periods: {
            ...state.entities.periods,
            [action.payload.periodId]: {
              ...state.entities.periods[action.payload.periodId],
              quarterlyStatus: action.payload.quarterlyStatus,
              quarterlyStatusValue: action.payload.quarterlyStatusValue
            }
          }
        }

      };

    case types.DUE_DATE_SET:
      const {periodId, dueDate} = action.payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          periods: {
            ...state.entities.periods,
            [periodId]: {
              ...state.entities.periods[periodId],
              dueDate
            }
          }
        }
      };

    case types.ACTIVE_TAB_SET:
      return {
        ...state,
        uiState: {
          ...state.uiState,
          activeTab: action.payload
        }
      };

    case types.SAMPLE_UI_STATE_RESET:
      return {...state, uiState: {...initialState.uiState}, entities: {...state.entities}};

    default:
      return state;
  }
}

function updateRecord(state, {payload: {recordId, recordStatus, recordStatusValue, timestamp, user}}) {
  const record = state.entities.patients[recordId];
  const newRecord = {...record, recordStatus, recordStatusValue,lastSavedBy: user, statusDate: timestamp};

  return {
    ...state,
    entities: {
      ...state.entities,
      patients: {
        ...state.entities.patients,
        [recordId]: newRecord
      }
    }
  };
}


// WEBPACK FOOTER //
// ./src/modules/sample/sample.reducer.js